import ReactDOM from 'react-dom/client';
import AppRouter from './router';

import { Provider } from 'react-redux';
import store from './store';

import { createTheme, ThemeProvider } from '@mui/material';

import './assets/scss/styles.scss';

const theme = createTheme({
  palette: {
    primary: {
      main: '#f50057',
    },
  },
  components: {
    MuiMenuItem: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            backgroundColor: 'rgba(0, 0, 0, 0.08)',
            '&:hover': {
              backgroundColor: 'rgba(0, 0, 0, 0.08)',
            },
            '&.Mui-focusVisible': {
              backgroundColor: 'rgba(0, 0, 0, 0.08)',
            },
          },
        },
      },
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ThemeProvider theme={theme}>
    <Provider store={store}>
      <AppRouter />
    </Provider>
  </ThemeProvider>
);
